<template>
    <div>
        <div class="popup-overlay" v-if="showPopup">
            <div class="popup-content">
                <div style="display: flex; align-items: center; margin-bottom: 10px;">
                    <h6>{{ $resourceString["product.search.pdf.modal.heading"] }}</h6>
                    <button class="popup-close-button" @click="closePopup">
                        <span class="png-icon png-icon-icons-symbols--k-txtclose"></span>
                    </button>
                </div>
                <div>
                    <p>
                        {{ $resourceString["product.search.pdf.modal.body"] }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        showPopup: Boolean,
    },
    methods: {
        closePopup() {
            this.$emit("close");
        },
    },
};
</script>
  
<style></style>